export default {"src":"/_next/static/media/address-jumbotron-wave-desktop.1c0cbdfa.svg","height":74,"width":1280,"blurWidth":0,"blurHeight":0};